/**
 * Contact.js
 *
 * Setup contact form functionality
 *
 * @param $ jquery
 */
const ContactForm = ( $ )=> {
	'use strict';

	const send = (data) => {

		const url = main_script.ajaxurl; // eslint-disable-line

		$.post(url, data, function (response) {
			if (response.success) {
				$("#response-area").addClass("msg-success").removeClass("msg-error");
			} else {
				$("#response-area").addClass("msg-error");
			}

			const formFields = Object.keys (response.data);

			formFields.forEach(field => {
				$(`#${field}-response-area`).html(response.data[field]);
			});
		});
	}

	const init = () => {

		$("#submit-contact").click(function (e) {
			e.preventDefault();

			const fromFieldNames = ["name", "email", "subject", "message"];

			fromFieldNames.forEach(field => {
				$(`#${field}-response-area`).html("");
			})

			let grecaptcha = window.grecaptcha;

			grecaptcha
				.execute("6Lcqw7gZAAAAAGWHfQ-LlB2JqQ4oesD39NTVvLwq", {
					action: "contact",
				})
				.then((token) => {
					let recaptchaResponse = document.getElementById("recaptcha_response");
					recaptchaResponse.value = token;
					const ajaxFormData = $("#contact-form").serialize();
					send(ajaxFormData);
				});
		});
	}

	init();

};

export default ContactForm;
